import logo from '../../assets/images/logo-small.png';
import { useUser } from '../../components/Auth/User';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { AppBar, Avatar, Box, Container, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import Loader from '../Loader/Loader';
import {
  HomeRounded as HomeRoundedIcon,
  SnippetFolderRounded as SnippetFolderRoundedIcon,
  BallotRounded as BallotRoundedIcon,
  MenuRounded as MenuRoundedIcon,
  QrCode2Rounded as QrCode2RoundedIcon,
} from '@mui/icons-material';
import { EtiquetaAmbiente } from './components/EtiquetaAmbiente';
import { useLocation, useHistory } from 'react-router-dom';
import MobileBottomBar from './MobileBottomBar';
import { useInfoAfiliado } from '../../components/Afiliados/InfoAfiliadoProvider';
import { PrivatePages } from '../../routes/Pages';
import { CampanaNotificaciones } from './components/CampanaNotificaciones';

const drawerWidth = 260;

export const MenuMobile = (props) => {
  const location = useLocation();
  const history = useHistory();
  const theme = useTheme();
  const { user } = useUser();
  const { infoAfiliado } = useInfoAfiliado();
  const { nombre } = infoAfiliado?.personaFisica || {};

  if (!user) {
    return (
      <Box sx={{ display: 'flex' }}>
        <AppBar
          position='fixed'
          sx={{
            ml: { md: `${drawerWidth}px` },
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
        >
          <Loader id='headerLoader' />
        </AppBar>
        <Container
          id='main'
          component='main'
          sx={{ flexGrow: 1, p: 3, width: { md: `calc(100% - ${drawerWidth}px)` } }}
          maxWidth='lg'
        >
          {/* <Toolbar /> */}
          {props.children}
        </Container>
      </Box>
    );
  }

  /**
   * Obtiene el label del menú activo según la ruta actual
   */
  const getActiveMenuLabel = () => {
    const allMenus = {
      ...PrivatePages,
    };

    const activeItem = Object.values(allMenus).find((item) => {
      return item.to === location.pathname;
    });
    return activeItem ? activeItem.label : '';
  };

  const title = getActiveMenuLabel();

  return (
    <Box sx={{ display: 'flex' }}>
      {/* <CssBaseline /> */}
      <AppBar
        position='fixed'
        sx={{
          ml: { md: `${drawerWidth}px` },
          zIndex: (theme) => theme.zIndex.drawer + 1,
          background: theme.palette.gradient.main,
          boxShadow: {
            xs: 'none',
            md: '0px 1px 5px 0px rgb(0 0 0 / 10%), 0px 2px 2px 0px rgb(0 0 0 / 10%), 0px 3px 1px -2px rgb(0 0 0 / 10%)',
          },
        }}
      >
        <Toolbar sx={{ background: theme.palette.gradient.main }}>
          <Link
            to='/'
            style={{
              textDecoration: 'none',
              color: 'white',
              display: 'inline-flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '10px',
            }}
          >
            <Avatar
              alt=''
              src={logo}
              sx={{ filter: 'drop-shadow(3px 0px 3px rgba(0, 0, 0, .5))' }}
            />
            {title === 'Inicio' && (
              <Typography variant='h6' fontWeight={'500'} noWrap component='h1'>
                Mi OSER
              </Typography>
            )}

            {title !== 'Inicio' && (
              <Box>
                <Typography variant='p'>{title}</Typography>
              </Box>
            )}

            {!title && (
              <Typography variant='h6' noWrap component='div'>
                Mi OSER
                <Typography mx={1} variant='overline' gutterBottom={false} component={'span'}>
                  {process.env.REACT_APP_MI_IOSPER_VERSION_BETA_TEXT || ''}
                </Typography>
              </Typography>
            )}
            {/* <Box>
              <Typography variant='h6' noWrap component='div'>
                Mi OSER
                <Typography mx={1} variant='overline' gutterBottom={false}>
                  {process.env.REACT_APP_MI_IOSPER_VERSION_BETA_TEXT || ''}
                </Typography>
              </Typography>
              <Typography variant='caption' sx={{ display: 'block', marginTop: '-5px' }}>
                {title}
              </Typography>
            </Box> */}
          </Link>
          <Box sx={{ flexGrow: 1 }} />
          <EtiquetaAmbiente />
          <CampanaNotificaciones />
          <Box sx={{ mr: 1 }} />
        </Toolbar>
        <Loader id='headerLoader' />
      </AppBar>

      <MobileBottomBar
        value={location.pathname.replace('/', '')}
        onChange={(val) => history.push(`/${val}`)}
        actions={[
          { label: 'Inicio', icon: <HomeRoundedIcon />, value: '' },
          { label: 'Autorizaciones', icon: <SnippetFolderRoundedIcon />, value: 'autorizaciones' },
          { label: 'Cartilla', icon: <BallotRoundedIcon />, value: 'cartilla' },
          { label: 'Más', icon: <MenuRoundedIcon />, value: 'menu' },
        ]}
        fab={{
          icon: <QrCode2RoundedIcon />,
          onClick: () => history.push('/read-qr'), //  agrego ruta para que administre la lectura QR y redirija a la funcionalidad que corresponda
        }}
      />

      <Container
        id='main'
        component='main'
        sx={{ flexGrow: 1, p: 3, width: { md: `calc(100% - ${drawerWidth}px)` } }}
        maxWidth='lg'
      >
        <Toolbar variant='regular' />
        {props.children}
        <Toolbar sx={{ height: 80 }} />
      </Container>
    </Box>
  );
};
